import { render, staticRenderFns } from "./ModalProps.vue?vue&type=template&id=2388fc6e&scoped=true&"
import script from "./ModalProps.vue?vue&type=script&lang=js&"
export * from "./ModalProps.vue?vue&type=script&lang=js&"
import style0 from "./ModalProps.vue?vue&type=style&index=0&id=2388fc6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2388fc6e",
  null
  
)

export default component.exports